
/**
 * Created by nijin on 19/1/17.
 */
import { Injectable, } from '@angular/core';
import {RequestOptions, Response, URLSearchParams} from '@angular/http';
import {Observable, Subject} from 'rxjs';
import {environment} from '../../environments/environment';
import {ISelectedSchema} from '../things/model/ISelectedSchema';
import {EntityService} from '../core/entity.service';
import {HttpService} from '../auth/http.client.service';
import {NotificationBarService} from '../core/notify/notification.service';
import {NotificationType} from '../core/notify';
import {AuthService} from '../auth/auth.service';
import {GlobalService} from '../global/global.service';
import {EventData} from './model/schema.model';
import {Cookie} from 'ng2-cookies';

@Injectable()
export class SchemaService {
  private predefinedSchemaURI = `${environment.serviceBase}/templates`;
  private customSchemaURI = `${environment.serviceBase}/accounts/:accountId/schemas`;
  private thingTokenUri = `${environment.serviceBase}/accounts/:accountId/things/token`;
  private selectedSchemaSubject = new Subject<ISelectedSchema>();
  private selectedSchema = this.selectedSchemaSubject.asObservable();
  //private schemaCategorySub = new Subject<any>();
  private thingToken;
  private schema;

  constructor(private http: HttpService,
              private entityService: EntityService,
              private notifier: NotificationBarService,
              private authService: AuthService,
              private globalService: GlobalService
  ) { }

  setSelectedSchema(schema) {
    this.schema = this.entityService.clone(schema);
    this.selectedSchemaSubject.next({isEdited: false, schema: this.entityService.clone(schema)});
  }

  getSelectedSchema(): Observable<ISelectedSchema> {
    return this.selectedSchema;

  }
  getCurrentSchema() {
    return this.schema;
  }

  getThingToken() {
    return this.thingToken ;
  }

  resetThingToken() {
    this.thingToken = null;
  }

  saveSchema(schema): Observable<any> {
    let uri = this.http.buildPath(this.customSchemaURI,{accountId: this.authService.getCurrentAccount().id});
    return this.http.post(uri, schema)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getPredefinedSchemaList(params?: any): Observable<any>{
    let search = this.setParams(params);
    let options = new RequestOptions({ search: search });
    return this.http.get(`${this.predefinedSchemaURI}`, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getCustomSchemaList(params?: any):Observable<any>{
    let search = this.setParams(params);
    let options = new RequestOptions({ search: search });
    let uri = this.http.buildPath(this.customSchemaURI,{accountId:this.authService.getCurrentAccount().id});
    return this.http.get(uri, options)
      .map(this.extractData)
      .catch(this.handleError)
  }

  isCustomSchema(schema): boolean{
    return !!schema.accountId;
  }

  getSchema(schemaId): Observable<any>{
    let uri = this.http.buildPath(this.customSchemaURI,{accountId:this.authService.getCurrentAccount().id});
    return this.http.get(`${uri}/${schemaId}`)
      .map((response)=>{return response.json()})
      .catch(this.handleError)
  }

   getSchemaDataForPreview(schema){
       return this.entityService.merge({}, schema) ;
   }

  getEventData({thing: thing, schema: schema}) {
    if (!schema && !this.schema)
      return null;
    let schemaModel = schema ? schema : this.schema;
    let eventData = new EventData();

    schemaModel.attributes.forEach((attribute) => {
      //value set as per the data type.. Remove this when it is integrate with api
      eventData.attributes[attribute.name] = this.globalService.getValueByType(attribute);
    });

    schemaModel.location.forEach((location) => {
      if (location.fields) {
        eventData.location[location.name] = {};

        location.fields.forEach((field) => {
          //value set as per the data type.. Remove this when it is integrate with api
          eventData.location[location.name][field.name] = this.globalService.getValueByType(field);
        })
      }
      else {
        //value set as per the data type.. Remove this when it is integrate with api
        eventData.location[location.name] = this.globalService.getValueByType(location);
      }
    });

    eventData.accountId = this.authService.getCurrentAccount().id;
    eventData.deviceId = thing? thing.token : this.thingToken;
    eventData.timestamp =  new Date().getTime();
    //eventData.stationary = schema['stationary'];
    //eventData.predefinedLocation = schema['predefinedLocation'];
    return this.entityService.merge({}, eventData);
  }

  generateThingToken(): Observable<any>{
    let tokenUri = this.http.buildPath(this.thingTokenUri,{accountId:this.authService.getCurrentAccount().id});
    return this.http.get(tokenUri)
      .map((response)=>{let res = response.json(); this.thingToken = res.data})
      .catch(this.handleError);
  }

 static setNotifierPreference() {
    Cookie.set('doNotShowSchemaNotifier','true');
 }

 static getNotifierPreference(): string{
   return Cookie.get('doNotShowSchemaNotifier');
 }

  private setParams = (args) => {
    let params: URLSearchParams = new URLSearchParams();
    for (let key in args) {
      if (args.hasOwnProperty(key)) {
        params.set(key, args[key]);
      }
    }

    return params;
  };

  private  extractData = (response: Response) => {
    let body = response.json();
    if(response.status === 201){
      this.notifier.create({message: body.status.message, type: NotificationType.Success});
    }
    return body.data || { };
  };

  private handleError = (error: Response | any) => {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      errMsg = body.status ? body.status.message : body;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
      this.notifier.create({message: errMsg, type: NotificationType.Error});

    return Observable.throw(errMsg);
  };


}




// WEBPACK FOOTER //
// ./src/app/schema/schema.service.ts